import React, { useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

function Register({ onRegister }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${API_URL}/register`, { 
        username: username.toLowerCase(), // Convert username to lowercase
        password 
      });
      onRegister(response.data.token);
    } catch (error) {
      console.error('Error registering:', error);
    }
  };

  return (
    <form onSubmit={handleRegister}>
      <h2>Register</h2>
      <div>
        <input type="text" value={username} placeholder="Choose username" onChange={(e) => setUsername(e.target.value)} required />
      </div>
      <div>
        <input type="password" value={password} placeholder="Choose password" onChange={(e) => setPassword(e.target.value)} required />
      </div>
      <button type="submit">Register</button>
    </form>
  );
}

export default Register;
